import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const usersMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'datetime',
        format: DATETIME_FORMAT,
        description: 'created_on',
        label: 'Created On',
        'min-width': 150,
        name: 'created_on',
        sortable: true
      },
      {
        datatype: 'string',
        description: 'firstname',
        label: 'First Name',
        'min-width': 150,
        name: 'firstname',
        sortable: true
      },
      {
        datatype: 'string',
        description: 'lastname',
        label: 'Last Name',
        'min-width': 150,
        name: 'lastname',
        sortable: true
      },
      {
        datatype: 'string',
        description: 'email',
        label: 'Email',
        'min-width': 240,
        name: 'email',
        sortable: true
      },
      {
        datatype: 'string',
        description: 'active',
        label: 'Is Active',
        'min-width': 100,
        name: 'active',
        sortable: true,
        display: 'colorTag',
        displayKey: [
          {
            key: true,
            display: 'Active',
            textColor: '#409eff',
            color: '#ecf5ff'
          },
          {
            key: false,
            display: 'Inactive',
            textColor: '#409eff',
            color: '#ecf5ff'
          }
        ]
      },
      {
        datatype: 'array',
        display: 'tag',
        description: 'User Roles',
        label: 'User Roles',
        'min-width': 250,
        name: 'roleNames',
        sortable: true
      }
    ]
  }
}

export { usersMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/users/users-meta.js